import BaseMetricCard, {
  MetricCardConfig,
} from "../../../Common/BaseMetricCard";
import { WellnessScoreStatus } from "../../../Common/types";

export interface BreathingRateCardProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onManualEntryClick?: () => void;
}

const config: MetricCardConfig = {
  translationPrefix: "BreathingRate",
  analyticsSource: "Health Score - breathing rate",
  manualEntryRoute: "/home/health-score/breathing-rate-manual-entry",
};

export default function BreathingRateCard(props: BreathingRateCardProps) {
  return <BaseMetricCard {...props} config={config} />;
}
